// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, urlSearchParamsBodySerializer } from '@hey-api/client-axios';
import type { AuthLoginAuthLoginPostData, AuthLoginAuthLoginPostResponse, AuthLoginAuthLoginPostError, AuthRefreshAuthRefreshPostData, AuthRefreshAuthRefreshPostResponse, AuthRefreshAuthRefreshPostError, GroupsAndUsersGroupsAndUsersGetData, GroupsAndUsersGroupsAndUsersGetResponse, GroupsAndUsersGroupsAndUsersGetError, GetProfileProfileGetData, GetProfileProfileGetResponse, GetProfileProfileGetError, UpdateProfileProfilePatchData, UpdateProfileProfilePatchResponse, UpdateProfileProfilePatchError, NotificationsSettingsNotificationsGetData, NotificationsSettingsNotificationsGetResponse, NotificationsSettingsNotificationsGetError, CodesCodesGetData, CodesCodesGetResponse, CodesCodesGetError, ProfileCodesCodesProfileGetData, ProfileCodesCodesProfileGetResponse, ProfileCodesCodesProfileGetError, EntityEntitiesEntityIdGetData, EntityEntitiesEntityIdGetResponse, EntityEntitiesEntityIdGetError, NewsCommentsNewsNewsIdCommentsGetData, NewsCommentsNewsNewsIdCommentsGetResponse, NewsCommentsNewsNewsIdCommentsGetError, NewsNewsNewsIdGetData, NewsNewsNewsIdGetResponse, NewsNewsNewsIdGetError, NewsEventsNewsNewsIdEventsGetData, NewsEventsNewsNewsIdEventsGetResponse, NewsEventsNewsNewsIdEventsGetError, PickNewsNewsIdPickPostData, PickNewsNewsIdPickPostResponse, PickNewsNewsIdPickPostError, SourceLogsSourcesSourceIdLogsGetData, SourceLogsSourcesSourceIdLogsGetResponse, SourceLogsSourcesSourceIdLogsGetError, LeadEventsLeadsLeadIdEventsGetData, LeadEventsLeadsLeadIdEventsGetResponse, LeadEventsLeadsLeadIdEventsGetError, NewsbreakEventsNewsbreaksNewsbreakIdEventsGetData, NewsbreakEventsNewsbreaksNewsbreakIdEventsGetResponse, NewsbreakEventsNewsbreaksNewsbreakIdEventsGetError, PickAsoiNotesNoteIdPickPostData, PickAsoiNotesNoteIdPickPostResponse, PickAsoiNotesNoteIdPickPostError, NoteEventsAsoiNotesNoteIdEventsGetData, NoteEventsAsoiNotesNoteIdEventsGetResponse, NoteEventsAsoiNotesNoteIdEventsGetError } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class AuthService {
    /**
     * Сформировать токен доступа и рефреш-токен
     * Сформировать токен доступа и рефреш-токен.
     */
    public static authLoginAuthLoginPost<ThrowOnError extends boolean = false>(options: Options<AuthLoginAuthLoginPostData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<AuthLoginAuthLoginPostResponse, AuthLoginAuthLoginPostError, ThrowOnError>({
            ...urlSearchParamsBodySerializer,
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/auth/login',
            ...options,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...options?.headers
            }
        });
    }
    
    /**
     * Обновить токен доступа и рефреш-токен
     * Обновить токен доступа и рефреш-токен.
     */
    public static authRefreshAuthRefreshPost<ThrowOnError extends boolean = false>(options?: Options<AuthRefreshAuthRefreshPostData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).post<AuthRefreshAuthRefreshPostResponse, AuthRefreshAuthRefreshPostError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/auth/refresh',
            ...options
        });
    }
    
}

export class UsersService {
    /**
     * Получить списки групп с пользователями и пользователей без групп
     * Вернуть списки групп с пользователями и пользователей без групп.
     */
    public static groupsAndUsersGroupsAndUsersGet<ThrowOnError extends boolean = false>(options?: Options<GroupsAndUsersGroupsAndUsersGetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GroupsAndUsersGroupsAndUsersGetResponse, GroupsAndUsersGroupsAndUsersGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/groups_and_users',
            ...options
        });
    }
    
}

export class GroupsService {
    /**
     * Получить списки групп с пользователями и пользователей без групп
     * Вернуть списки групп с пользователями и пользователей без групп.
     */
    public static groupsAndUsersGroupsAndUsersGet<ThrowOnError extends boolean = false>(options?: Options<GroupsAndUsersGroupsAndUsersGetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GroupsAndUsersGroupsAndUsersGetResponse, GroupsAndUsersGroupsAndUsersGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/groups_and_users',
            ...options
        });
    }
    
}

export class ProfileService {
    /**
     * Получить данные профиля пользователя
     * Вернуть данные профиля пользователя.
     */
    public static getProfileProfileGet<ThrowOnError extends boolean = false>(options?: Options<GetProfileProfileGetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<GetProfileProfileGetResponse, GetProfileProfileGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/profile',
            ...options
        });
    }
    
    /**
     * Обновить данные профиля пользователя
     * Обновить и вернуть данные профиля пользователя.
     */
    public static updateProfileProfilePatch<ThrowOnError extends boolean = false>(options: Options<UpdateProfileProfilePatchData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).patch<UpdateProfileProfilePatchResponse, UpdateProfileProfilePatchError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/profile',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
}

export class NotificationsService {
    /**
     * Получить настройки уведомлений
     * Вернуть настройки уведомлений.
     */
    public static notificationsSettingsNotificationsGet<ThrowOnError extends boolean = false>(options?: Options<NotificationsSettingsNotificationsGetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<NotificationsSettingsNotificationsGetResponse, NotificationsSettingsNotificationsGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/notifications',
            ...options
        });
    }
    
}

export class CodesService {
    /**
     * Получить дерево кодов
     * Вернуть дерево кодов.
     */
    public static codesCodesGet<ThrowOnError extends boolean = false>(options?: Options<CodesCodesGetData, ThrowOnError>) {
        return (options?.client ?? _heyApiClient).get<CodesCodesGetResponse, CodesCodesGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/codes',
            ...options
        });
    }
    
    /**
     * Получить дерево кодов в рамках профиля кодов
     * Вернуть дерево кодов в рамках профиля кодов.
     */
    public static profileCodesCodesProfileGet<ThrowOnError extends boolean = false>(options: Options<ProfileCodesCodesProfileGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<ProfileCodesCodesProfileGetResponse, ProfileCodesCodesProfileGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/codes/profile',
            ...options
        });
    }
    
}

export class EntitiesService {
    /**
     * Найти сущность по идентификатору
     * Вернуть новость.
     */
    public static entityEntitiesEntityIdGet<ThrowOnError extends boolean = false>(options: Options<EntityEntitiesEntityIdGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<EntityEntitiesEntityIdGetResponse, EntityEntitiesEntityIdGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/entities/{entity_id}',
            ...options
        });
    }
    
}

export class NewsService {
    /**
     * Получить комментарии к новости
     * Вернуть список комментариев к новости.
     */
    public static newsCommentsNewsNewsIdCommentsGet<ThrowOnError extends boolean = false>(options: Options<NewsCommentsNewsNewsIdCommentsGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<NewsCommentsNewsNewsIdCommentsGetResponse, NewsCommentsNewsNewsIdCommentsGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/news/{news_id}/comments',
            ...options
        });
    }
    
    /**
     * Найти новость по идентификатору
     * Вернуть новость.
     */
    public static newsNewsNewsIdGet<ThrowOnError extends boolean = false>(options: Options<NewsNewsNewsIdGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<NewsNewsNewsIdGetResponse, NewsNewsNewsIdGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/news/{news_id}',
            ...options
        });
    }
    
    /**
     * Получить события новости
     * Вернуть список событий инфоповода.
     */
    public static newsEventsNewsNewsIdEventsGet<ThrowOnError extends boolean = false>(options: Options<NewsEventsNewsNewsIdEventsGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<NewsEventsNewsNewsIdEventsGetResponse, NewsEventsNewsNewsIdEventsGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/news/{news_id}/events',
            ...options
        });
    }
    
    /**
     * Взять новость на редактирование
     * Взять новость на редактирование.
     */
    public static pickNewsNewsIdPickPost<ThrowOnError extends boolean = false>(options: Options<PickNewsNewsIdPickPostData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PickNewsNewsIdPickPostResponse, PickNewsNewsIdPickPostError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/news/{news_id}/pick',
            ...options
        });
    }
    
}

export class SourcesService {
    /**
     * Получить логи источника
     * Вернуть список логов источника.
     */
    public static sourceLogsSourcesSourceIdLogsGet<ThrowOnError extends boolean = false>(options: Options<SourceLogsSourcesSourceIdLogsGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<SourceLogsSourcesSourceIdLogsGetResponse, SourceLogsSourcesSourceIdLogsGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/sources/{source_id}/logs',
            ...options
        });
    }
    
}

export class LeadsService {
    /**
     * Получить события лида
     * Вернуть список событий лида.
     */
    public static leadEventsLeadsLeadIdEventsGet<ThrowOnError extends boolean = false>(options: Options<LeadEventsLeadsLeadIdEventsGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<LeadEventsLeadsLeadIdEventsGetResponse, LeadEventsLeadsLeadIdEventsGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/leads/{lead_id}/events',
            ...options
        });
    }
    
}

export class NewsbreaksService {
    /**
     * Получить события инфоповода
     * Вернуть список событий инфоповода.
     */
    public static newsbreakEventsNewsbreaksNewsbreakIdEventsGet<ThrowOnError extends boolean = false>(options: Options<NewsbreakEventsNewsbreaksNewsbreakIdEventsGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<NewsbreakEventsNewsbreaksNewsbreakIdEventsGetResponse, NewsbreakEventsNewsbreaksNewsbreakIdEventsGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/newsbreaks/{newsbreak_id}/events',
            ...options
        });
    }
    
}

export class AsoiService {
    /**
     * Взять заметку АСОИ в работу
     * Взять заметку АСОИ в работу.
     */
    public static pickAsoiNotesNoteIdPickPost<ThrowOnError extends boolean = false>(options: Options<PickAsoiNotesNoteIdPickPostData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).post<PickAsoiNotesNoteIdPickPostResponse, PickAsoiNotesNoteIdPickPostError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/asoi/notes/{note_id}/pick',
            ...options
        });
    }
    
    /**
     * Получить события заметки АСОИ
     * Вернуть список событий заметки АСОИ.
     */
    public static noteEventsAsoiNotesNoteIdEventsGet<ThrowOnError extends boolean = false>(options: Options<NoteEventsAsoiNotesNoteIdEventsGetData, ThrowOnError>) {
        return (options.client ?? _heyApiClient).get<NoteEventsAsoiNotesNoteIdEventsGetResponse, NoteEventsAsoiNotesNoteIdEventsGetError, ThrowOnError>({
            security: [
                {
                    scheme: 'bearer',
                    type: 'http'
                },
                {
                    scheme: 'bearer',
                    type: 'http'
                }
            ],
            url: '/asoi/notes/{note_id}/events',
            ...options
        });
    }
    
}